import Resource from "./resource";

export class CertificateConfigurationResource extends Resource {
    Name: string;
    Thumbprint: string;
    SignatureAlgorithm: string;
}

export default CertificateConfigurationResource;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/resources/certificateConfigurationResource.ts